import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { BaseEntity } from "yt-ng-framework";

export class UlazniDokumentDobavljacaView extends BaseEntity{
    constructor(){
        super();
    }
    PodVrstaDokumentaStavka: string;
    BrojDokumenta: string;
    Datum: NgbDate;  
    BrojUlaznogDokumentaDobavljaca: string;
    Komitent: string; 
    KomitentMesto: string; 
    Ukupno: number;
    BrojDokumentaSaFormatom: string;
    StatusGenericName: string;
    StatusColor:string;
    StatusTooltip:string;
    ProvajderID:number;
    OsvezivogStatusa:boolean;
    UlaziUSumu: boolean;
    Komentar: string;
    NoviKomitent: boolean;
    EdokumentID: number;
    Trosak: boolean;

    Deserialize(input: any){
        this.ID = input.ID;
        this.PodVrstaDokumentaStavka = input.PodVrstaDokumentaStavka;
        this.BrojDokumenta = input.BrojDokumenta;
        this.Datum = input.Datum;
        this.BrojUlaznogDokumentaDobavljaca = input.BrojUlaznogDokumentaDobavljaca;
        this.Komitent = input.Komitent;
        this.KomitentMesto = input.KomitentMesto;
        this.Ukupno = input.Ukupno;
        this.BrojDokumentaSaFormatom = input.BrojDokumentaSaFormatom;
        this.StatusGenericName = input.StatusGenericName;
        this.StatusColor=input.StatusColor;
        this.StatusTooltip= input.StatusTooltip;
        this.ProvajderID=input.ProvajderID;
        this.OsvezivogStatusa=input.OsvezivogStatusa;
        this.UlaziUSumu = input.UlaziUSumu;
        this.Komentar = input.Komentar; 
        this.NoviKomitent = input.NoviKomitent;
        this.EdokumentID = input.EdokumentID;
        this.Trosak = input.Trosak;        
        return this;
    }

    Serialize(input: UlazniDokumentDobavljacaView){
        return input;
    }
}